import { observer } from 'mobx-react';
import * as React from 'react';
import { AnalyticsTrigger, Anchor, Image, Text } from 'telia-front-react';
import { Movie } from '../stores/movierental/MovieRentalCatalogStore';

interface MovieRentalCardProps {
  movie: Movie;
  darkBackground?: boolean;
  htmlTitle?: boolean;
}

function MovieRentalCard(props: MovieRentalCardProps): JSX.Element {
  const { movie, darkBackground, htmlTitle } = props;
  const urls: string[] = [];
  if (movie.images?.small) {
    urls.push(`${movie.images.small} 130w`);
  }
  if (movie.images?.medium) {
    urls.push(`${movie.images.medium} 260w`);
  }
  if (!urls.length) {
    urls.push('//place-hold.it/130x175');
  }
  const srcset = urls.join();

  return (
    <AnalyticsTrigger trigger={{ id: `Link - Movie - ${movie.name}`, callback: 'onClick' }}>
      <Anchor url={`?${movie.type}=${movie.id}`} isTextColor={true}>
        <Text className="text-center">
          {htmlTitle ? (
            <div dangerouslySetInnerHTML={{ __html: movie.name }} />
          ) : (
            <p className={`text text-bold ${darkBackground ? 'text-white' : ''}`}>{movie.name}</p>
          )}
          <Image role="presentation" key={movie.id} srcset={srcset} align="center" width={130} />
        </Text>
      </Anchor>
    </AnalyticsTrigger>
  );
}

export default observer(MovieRentalCard);
